import { NavLink, Outlet } from "react-router"
import { cn } from "@/lib/utils"
import { PostHogPageView } from "@/feature/posthog/page-view"

export const RootLayout = () => (
  <>
    <nav className="flex p-4 border fixed top-0 left-0 min-h-14 w-full z-10 bg-white">
      <NavLink
        to="/"
        className={({ isActive }) =>
          cn(
            isActive ? `text-blue-400` : `text-stone-700`,
            `hover:text-blue-400 hover:underline`
          )
        }
      >
        Home
      </NavLink>
    </nav>
    <div className="pt-14">
      <Outlet />
    </div>
    <PostHogPageView />
  </>
)
